module.exports = __webpack_public_path__ + "media/src/assets/Images/Trust-8e810c626d36d64ee2d81ce4a2d92afe.svg";